import { CustomModal } from "@pw/batch-widgets";
import { X } from "lucide-react";
import { FC, useEffect, useState } from "react";
import style from "./style.module.css";
import { VideoDetails } from "@components/Sales/batch.type";
import { getAccessToken, getRandomId } from "@api/index";
import { PLAYER_ACTIONS, VIDEO_TYPE } from "@utils/constants";
import { Base64 } from "@utils/encode-utilities";
import { cn } from "@utils/utilities";
import useGetMahapackDemoVideos from "@api/hooks/ambassador-batch/useGetMahapackDemoVideos";

interface props {
  open: boolean;
  onClose: () => void;
  selectedContent: subContentType;
}

interface subContentType {
  description: string;
  displayName: string;
  videoDetails: VideoDetails;
}

const InfoModal: FC<props> = ({ open, onClose, selectedContent }) => {
  const videoId = selectedContent?.videoDetails?.videoId || "";
  const [iframeURL, setIframeURL] = useState<string>("");

  const { data: demoVideos, isLoading } = useGetMahapackDemoVideos({
    enabled: videoId?.length > 0,
    query: { ids: videoId },
  });

  useEffect(() => {
    if (demoVideos?.length) {
      const demoVideo = demoVideos[0];
      const videoType = VIDEO_TYPE[demoVideo?.videoType as keyof typeof VIDEO_TYPE];
      const videoUrl =
        videoType === VIDEO_TYPE.penpencilvdo
          ? demoVideo?.videoDetails?.videoUrl
          : demoVideo?.videoDetails?.embedCode;

      if (videoType && videoUrl) {
        const url = `${process.env.REACT_APP_VIDEO_PLAYER_NEW}?type=${videoType
          }&src=${videoUrl}&actions=${Base64.encode(
            JSON.stringify(PLAYER_ACTIONS),
          )}&video_details=${Base64.encode(
            JSON.stringify({}),
          )}&token=${getAccessToken()}&random_id=${getRandomId()}&back_button=false&three_dots=false`;

        setIframeURL(url);
      }
    } else {
      setIframeURL("");
    }
  }, [demoVideos]);

  return (
    <CustomModal
      backdropClick={false}
      panelClassName={style.modal_wrapper}
      open={open}
      onClose={onClose}
    >
      <X onClick={onClose} className={style.close} />

      {isLoading ? (
        <div className={cn(style.player, style.pulse)} />
      ) : (
        <>
          {iframeURL && (
            <iframe
              className={style.player}
              allow="accelerometer; autoplay;fullscreen; encrypted-media;"
              src={iframeURL}
            />
          )}

          <section className={style.content}>
            <div className={style.heading}>{selectedContent?.displayName}</div>
            <div className={style.sub_heading}>
              {selectedContent?.description}
            </div>
          </section>
        </>
      )}
    </CustomModal>
  );
};

export default InfoModal;
